module.exports = __webpack_public_path__ + "img/home-hack-count.fa280b55.svg";